"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var useLazyRef = function useLazyRef(callback) {
  var ref = (0, _react.useRef)();
  if (ref.current === undefined) {
    ref.current = callback();
  }
  return ref;
};
var _default = useLazyRef;
exports.default = _default;